import type { RecordedAgenticChatSession } from 'features/embeddedSidebar/hooks/useAgenticChatSessionHistory'
import { useState } from 'react'

import {
  nextSeenCompletedTurnIds,
  type SeenCompletedTurnIds,
  unseenCompletedSessionKeys,
} from './agenticChatHistoryRowActivity'

export function useUnseenAgenticChatCompletions({
  activeSessionKey,
  sessions,
}: {
  activeSessionKey: string | undefined
  sessions: readonly RecordedAgenticChatSession[]
}): ReadonlySet<string> {
  const [lastSeenByKey, setLastSeenByKey] = useState<SeenCompletedTurnIds>({})
  const nextLastSeen = nextSeenCompletedTurnIds({
    activeSessionKey,
    previous: lastSeenByKey,
    sessions,
  })
  if (nextLastSeen !== lastSeenByKey) {
    setLastSeenByKey(nextLastSeen)
  }

  return new Set(
    unseenCompletedSessionKeys({
      activeSessionKey,
      lastSeenByKey: nextLastSeen,
      sessions,
    })
  )
}
